import o from "../shared/current/index.mjs";
import e from "./componentColors.mjs";
import m from "./componentStyles/index.mjs";
import { m as t } from "../../../colors-C72eWVhK.js";
const a = t({
  id: "whiteLabel",
  componentColors: e,
  components: m
}, o);
export {
  a as default
};
